// extracted by mini-css-extract-plugin
export default {"nearestDeliveryDate":"mUArmWv7kfAmSgqSi9JG"};
    if(module.hot) {
      // 1741945883113
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  